var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownTreeSideways(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.632352 1.242L7.20588 7.5L0.632353 13.758C0.544118 13.842 0.5 13.9447 0.5 14.066C0.5 14.1873 0.544118 14.29 0.632353 14.374C0.720588 14.458 0.828431 14.5 0.955883 14.5C1.08333 14.5 1.19118 14.458 1.27941 14.374L8.5 7.5L1.27941 0.626C1.19118 0.542001 1.08333 0.5 0.955882 0.5C0.828431 0.5 0.720588 0.542001 0.632352 0.626C0.544117 0.710001 0.499999 0.812667 0.499999 0.934C0.499999 1.05533 0.544117 1.158 0.632352 1.242Z",
    fill: "#415385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63235 1.242L12.2059 7.5L5.63235 13.758C5.54412 13.842 5.5 13.9447 5.5 14.066C5.5 14.1873 5.54412 14.29 5.63235 14.374C5.72059 14.458 5.82843 14.5 5.95588 14.5C6.08333 14.5 6.19118 14.458 6.27941 14.374L13.5 7.5L6.27941 0.626C6.19118 0.542001 6.08333 0.5 5.95588 0.5C5.82843 0.5 5.72059 0.542001 5.63235 0.626C5.54412 0.710001 5.5 0.812667 5.5 0.934C5.5 1.05533 5.54412 1.158 5.63235 1.242Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownTreeSideways);
export default __webpack_public_path__ + "static/media/dropdown-tree-sideways.bc3a65d5ced5ead1abc4fb584cea05f7.svg";
export { ForwardRef as ReactComponent };